import React from "react";

// antd v5 removed the Comment component (deprecated since v4). This
// reproduces its DOM structure/class names so the existing .ant-comment-*
// styles in src/styles/App.css keep applying without changes.
const Comment = ({ actions, author, avatar, content, datetime }) => (
  <div className="ant-comment">
    <div className="ant-comment-inner">
      <div className="ant-comment-avatar">{avatar}</div>
      <div className="ant-comment-content">
        <div className="ant-comment-content-author">
          <span className="ant-comment-content-author-name">{author}</span>
          <span className="ant-comment-content-author-time">{datetime}</span>
        </div>
        <div className="ant-comment-content-detail">{content}</div>
        {actions && actions.length > 0 && (
          <ul className="ant-comment-actions">
            {actions.map((action, index) => (
              <li key={index}>{action}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  </div>
);

export default Comment;
